import { Action } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { createStore } from '@redux/createStore';
import { RootState } from '@redux/index';
import { rootEpic } from './epics';
import { applicationOfflineState } from './dispatchers/applicationOfflineState';

// Init
// Epics are client-side data fetching, so only this browser store runs them; the server's store has none.
const epicMiddleware = createEpicMiddleware<Action, Action, RootState>();

const { store, history } = createStore(
  // eslint-disable-next-line no-underscore-dangle
  '__PRELOADED_STATE__' in window ? (window as any).__PRELOADED_STATE__ : undefined,
  [epicMiddleware],
);

epicMiddleware.run(rootEpic);
applicationOfflineState(store);

// Exports
export { store, history };
